import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

import { PaginationButton } from './PaginationButton';

export type PaginationProps = {
  pagination: Paginated<unknown>;
};

export function Pagination({ pagination }: PaginationProps) {
  const prevPage =
    typeof pagination.prvPage === 'number' ? pagination.prvPage + 1 : null;
  const nextPage =
    typeof pagination.nextPage === 'number' ? pagination.nextPage + 1 : null;

  const isPreviousPageDisabled = prevPage === null || prevPage < 0;
  const isNextPageDisabled = !nextPage;

  const getPageHref = (page: number | null) => {
    if (page === null) return;

    const url = new URL(window.location.href);

    url.searchParams.set('page', String(page));

    return url.href;
  };

  return (
    <div className="flex items-center gap-4">
      <PaginationButton
        icon={FiChevronLeft}
        href={getPageHref(prevPage)}
        disabled={isPreviousPageDisabled}
      >
        <span className="sr-only">
          {isPreviousPageDisabled ? 'No previous pages' : 'Previous'}
        </span>
      </PaginationButton>

      <span>{pagination.page + 1}</span>

      <PaginationButton
        icon={FiChevronRight}
        href={getPageHref(nextPage)}
        disabled={isNextPageDisabled}
      >
        <span className="sr-only">
          {isNextPageDisabled ? 'No more pages' : 'Next'}
        </span>
      </PaginationButton>
    </div>
  );
}
